import React from 'react';
import PropTypes from 'prop-types';
import './MediaLibraryButton.scss';

const icon = require('./assets/media-icon.svg');

const propTypes = {
  clickHandler: PropTypes.func.isRequired,
};


const MediaLibraryButton = ({ clickHandler }) => (
  <button style={{ backgroundImage: `url(${icon})` }} className="media-library-button" onClick={clickHandler}>
          Media Library
  </button>
);


MediaLibraryButton.propTypes = propTypes;


export default MediaLibraryButton;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/MediaLibraryButton/MediaLibraryButton.js